export default __webpack_public_path__ + "static/media/3132 spice rack B top.76c7b114.png";